/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable eqeqeq */
/* eslint-disable react/prop-types */
/* eslint-disable func-names */
/* eslint-disable indent */
import React, { useContext, useEffect, useState } from "react";
import {
  UmbracoContext,
  UmbracoStep,
  UmbracoChildren,
} from "../../../components/Umbraco/UmbracoContext";
import utils from "../../../utils";
import { isMobile } from "react-device-detect";
import { Row, LabelTitle, LabelNumric, Line, SelectField, useInput, ToggleGroup } from 'meitav-uikit';
import QuestionFooter from "./QuestionFooter";
const { UmbracoUtills } = utils;
import { Parser as HtmlToReactParser } from 'html-to-react';
const htmlToReactParser = new HtmlToReactParser();

export default function QuestionAll(props) {
  const { stepActive, anserOld, questions, resourceIcon, setNextDisabled } = props;
  const questionNow = `Question${stepActive}`;
  const htmlToReactParser = new HtmlToReactParser();
  const [firstLoad, setFirstLoad] = useState("");

  const resource = UmbracoStep(useContext(UmbracoContext).resource, questionNow);
  const questionsLs = UmbracoChildren(useContext(UmbracoContext).resource, questionNow);
  let newQuestionsList = {};
  const questionsMap = [];
  let j = 0;
  if (!(stepActive in { 3: 1, 4: 1 } && !isMobile)) {
    questionsMap[j] = { value: "0", text: "בחר" }
    j = j + 1;
  }
  questionsLs.map((singleElemJson, i) => {
    newQuestionsList = {
      value: singleElemJson[0].value,
      text: singleElemJson[1].value,
    };

    questionsMap[j] = newQuestionsList;
    j = j + 1;
  });

  const changeAnswerFunc = (valItem) => {
    console.log('valItem', valItem)
    let score = 0;
    let valueText = "";
    questionsLs.map(function (item, i) {
      const { value } = item[0];
      if (value == valItem) {
        score = item[2].value;
        valueText = item[1].value;
      }
    });
    props.changeAnswerFunc(stepActive, valItem, score, valueText);
  };
  const answer = useInput(null, questions[stepActive] ? questions[stepActive] : 0);

  useEffect(() => {
    if (answer.value && answer.value != 0) {
      setNextDisabled(false);
      changeAnswerFunc(answer.value);
    }
    else if ((stepActive in { 3: 1, 4: 1 } && !isMobile) && answer.value && answer.value != 0) {
      setNextDisabled(false);
      changeAnswerFunc(answer.value);
    }
  }, [answer.value]);
  if (firstLoad != stepActive) {
    setFirstLoad(stepActive);
    if (anserOld) {
      //במובייל הצורה שונה 
      if (!(stepActive in { 3: 1, 4: 1 } && !isMobile)) {
        answer.setValue(0);

        questionsLs.map(function (item, i) {
          if (anserOld == item[0].value) {
            answer.setValue(item[0].value);
            // answer.setValue({ value: item[0].value, text: item[1].value });
          }
        })

      }
      else

        answer.setValue(anserOld);
      changeAnswerFunc(anserOld);
      setNextDisabled(false);
    } else {
      setNextDisabled(true);
      //  if (!(stepActive in { 3: 1, 4: 1 } && !isMobile)) 
      //  answer.setValue({ value: "0", text: "בחר" });
      //  else  
      answer.setValue(0);

    }

  }
  return (
    <>
      <LabelTitle className='affix' >
        {htmlToReactParser.parse(UmbracoUtills.getValueByKey(resource, "title").replace("Sum", questions[1].toLocaleString(undefined, { maximumFractionDigits: 2 })))}
      </LabelTitle>
      <Row>
        {(stepActive == 3 || stepActive == 4) && !isMobile ? (
          <ToggleGroup {...answer} options={questionsMap} />
        ) : (
          <SelectField {...answer} options={questionsMap} />

        )}
      </Row>
      <QuestionFooter
        icon={UmbracoUtills.getValueByKey(resourceIcon, "icon")}
        iconUp={UmbracoUtills.getValueByKey(resourceIcon, "iconUp")}
        iconDown={UmbracoUtills.getValueByKey(resourceIcon, "iconDown")}
        whyImportant={UmbracoUtills.getValueByKey(resource, "whyImportant")}
        tooltip={UmbracoUtills.getValueByKey(resource, "tooltip")}
        text={UmbracoUtills.getValueByKey(resource, "text")}
        stepActive={stepActive}
      />
    </>
  );
}
